import React, { useState } from 'react';
import { HEARING_STATUS_OPTIONS, INTERPRETATION_STATUS_OPTIONS } from '../../../constants/contactOptionSets';

function DemographicsSection({ formData, handleChange, races, languages }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="form-section">
      <div className="section-title-row">
        <h3 className="section-title">Demographics</h3>
        <button
          type="button"
          className="section-collapse-toggle"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? 'Hide' : 'Show'}
        </button>
      </div>

      {open && (
        <div className="form-grid form-grid-3">
          <div className="form-group">
            <label>Race *</label>
            <select
              name="race_id"
              value={formData.race_id || ''}
              onChange={handleChange}
              required
            >
              <option value="">Select a race...</option>
              {(races || []).map((race) => (
                <option key={race.id} value={race.id}>
                  {race.description}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Gender *</label>
            <select
              name="gender"
              value={formData.gender || ''}
              onChange={handleChange}
              required
            >
              <option value="">Select...</option>
              <option value="M">Male</option>
              <option value="F">Female</option>
              <option value="U">Unknown</option>
            </select>
          </div>

          <div className="form-group">
            <label>Primary Language *</label>
            <select
              name="primary_language_id"
              value={formData.primary_language_id || ''}
              onChange={handleChange}
              required
            >
              <option value="">Select a language...</option>
              {(languages || []).map((language) => (
                <option key={language.id} value={language.id}>
                  {language.description}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Hearing Status</label>
            <select
              name="hearing_status"
              value={formData.hearing_status || ''}
              onChange={handleChange}
            >
              <option value="">Select...</option>
              {HEARING_STATUS_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Interpretation Status</label>
            <select
              name="interpretation_status"
              value={formData.interpretation_status || ''}
              onChange={handleChange}
            >
              <option value="">Select...</option>
              {INTERPRETATION_STATUS_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group form-group-checkbox-inline demographics-hispanic-cell">
            <label className="form-checkbox-inline">
              <input
                type="checkbox"
                name="hispanic"
                checked={!!formData.hispanic}
                onChange={handleChange}
              />
              <span>Hispanic</span>
            </label>
          </div>

          <div className="form-group">
            <label>Preferred Language</label>
            <select
              name="preferred_language_id"
              value={formData.preferred_language_id || ''}
              onChange={handleChange}
            >
              <option value="">Select a language...</option>
              {(languages || []).map((language) => (
                <option key={language.id} value={language.id}>
                  {language.description}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
    </div>
  );
}

export default DemographicsSection;
